<template>
    <div>
        <div class="page-title">
            <h4 v-if='this.contact'> {{$t('txt.contact')}}: {{this.contact.name}}</h4>
        </div>
        <div class="table-header edit-header">
            <div class="search-box" v-if="$can(['update contact'])">
                <router-link :to="`/contacts/${contact.id}/edit`">
                    <button type="button" class="add-user edit-button">
                        <i class="far fa-edit"></i>
                        <span> {{$t('placeholder.editeaza')}} </span>
                    </button>
                </router-link>
            </div>
        </div>
        <form class="add-user-form">
            <div class="row">
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_1" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                        <i :class="input_field.icon"></i>
                                        <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_2" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                        <i v-bind:class="input_field.icon"></i>
                                        <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('placeholder.notite')}} </h4>
                    </div>
                    <div class="inner-location-group">
                        <textarea name='notes' disabled v-model="this.contact.notes"> </textarea>
                        <div class="save-contact-buttons">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import ContactsService from '../../api-services/contacts.service.js'

export default {
  name: 'ViewContact',
  data () {
    return {
      contact: null
    }
  },
  methods: {
    getContact () {
      ContactsService.get(this.$route.params.id)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.contact = response.data.data
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.nume'),
            inputValue: (this.contact) ? this.contact.name : null,
            icon: 'fas fa-user',
            validationRules: ''
          },
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            inputValue: (this.contact.user) ? this.contact.user.company_name : this.contact.company_name,
            icon: 'fas fa-building',
            validationRules: ''
          },
          {
            inputName: 'function',
            labelName: this.$t('placeholder.functie'),
            inputValue: (this.contact) ? this.contact.function : null,
            icon: 'fas fa-user-tie',
            validationRules: ''
          }
        ],
        column_2: [
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: (this.contact) ? this.contact.phone : null,
            icon: 'fas fa-phone',
            validationRules: 'numeric'
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: (this.contact) ? this.contact.email : null,
            icon: 'fas fa-envelope',
            validationRules: 'email'
          }
        ]
      }
    }
  },
  created () {
    this.getContact()
  }
}
</script>
